import React from 'react'
import styled from '@emotion/styled'
import { colors, radius, spacing } from '@mobi/component-library/Foundations'

const enum LocalConstants {
  ShareBetCardContainerClass = 'bet-selection-display__card',
  SharedBetWinResultClass = 'bet-selection-display__win-result',
  SharedBetNoPayoutResultClass = 'bet-selection-display__no-payout-result',
}

const Container: React.FC<{
  children: React.ReactNode
  displayStatus: 'win' | 'loss' | null
  styleOverride?: React.CSSProperties
}> = ({ displayStatus, styleOverride, children }) => {
  return (
    <WrapperStyled
      style={styleOverride}
      className={
        displayStatus === 'win'
          ? LocalConstants.SharedBetWinResultClass
          : displayStatus === 'loss'
            ? LocalConstants.SharedBetNoPayoutResultClass
            : ''
      }
    >
      {children}
    </WrapperStyled>
  )
}

const Inner: React.FC<{ children: React.ReactNode }> = ({ children }) => (
  <div className={LocalConstants.ShareBetCardContainerClass}>{children}</div>
)

export const BetSelectionContainer = {
  Container,
  Inner,
}

// ======
// Styles
// ======

const WrapperStyled = styled.div({
  position: 'relative',
  zIndex: 1,
  display: 'flex',
  flexDirection: 'column',
  gap: spacing.smx1,
  padding: spacing.sm,
  borderRadius: radius.lgx3,
  backgroundColor: colors.white,
  backgroundImage: `url("data:image/svg+xml,%3csvg width='100%25' height='100%25' xmlns='http://www.w3.org/2000/svg'%3e%3crect width='100%25' height='100%25' fill='none' rx='20' ry='20' stroke='%23E1DFE3' stroke-width='1' stroke-dasharray='15%2c 15' stroke-linecap='square'/%3e%3c/svg%3e")`,

  [`&.${LocalConstants.SharedBetWinResultClass}`]: {
    filter: `drop-shadow(0 0 ${spacing.smx2} ${colors.celery[300]})`,
    border: `0.3rem solid ${colors.celery[500]}`,
    background: colors.white,
  },

  [`&.${LocalConstants.SharedBetNoPayoutResultClass}`]: {
    background: 'none',
    border: `0.3rem solid ${colors.neutral[300]}`,
  },

  [`.${LocalConstants.ShareBetCardContainerClass}`]: {
    display: 'flex',
    flexDirection: 'column',
    gap: spacing.smx1,
  },
})
